import React from 'react';
import styles from './WorkflowTabs.module.less';
import {Button, Carousel, Col, Row, Typography} from 'antd';
import {useIntl} from 'gatsby-plugin-intl';
import {Link} from 'gatsby';
import useGlobalState from '../../hooks/useGlobalState';
import useBreakpoint from 'antd/es/grid/hooks/useBreakpoint';
import Lottie from 'react-lottie-segments';
import useAnimationSrc from '../../hooks/useAnimationSrc';

const WorkflowTabs = () => {
    const {Title} = Typography;
    const {formatMessage, locale} = useIntl();
    const globalState = useGlobalState();
    const category = globalState.activeCompetenciesTab;
    const isDesktop = useBreakpoint().xl;
    const getAnimationSrc = useAnimationSrc(category);

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: getAnimationSrc,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
        },
    };

    return (
        <div className={styles.section}>
            <div className="container">
                <Title level={3} className={styles.title}>
                    {formatMessage({id: 'workflow.title'})}
                </Title>
                <Carousel
                    autoplay
                    autoplaySpeed={10000}
                    dotPosition={isDesktop ? 'left' : 'top'}
                    effect="fade"
                    customPaging={(i) => (
                        <button className="ant-tabs-tab">
                            <span className={`${styles.badge} badge`}>{i + 1}</span>
                            <span className="tab-text">{formatMessage({id: `workflow.tab-${i}-${category}.title`})}</span>
                        </button>
                    )}
                    appendDots={(dots) => (
                        <div>
                            <div className={`ant-tabs ${isDesktop ? 'ant-tabs-left vertical-tabs-stepper' : 'ant-tabs-top horizontal-tabs-stepper'}`}>
                                <div className="ant-tabs-nav">
                                    <div className="ant-tabs-nav-list">
                                        {dots}
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    className="custom-carousel"
                >
                    {[...Array(5).keys()].map(i => (
                        <div className="ant-tabs-pane" role="tabpanel">
                            <Row gutter={60}>
                                <Col xs={12} sm={12} md={12} lg={7}>
                                    <div className={styles.placeholder}>
                                        <Lottie options={defaultOptions} />
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} md={12} lg={5}>
                                    <p className={styles.description}>
                                        {formatMessage({id: `workflow.tab-${i}-${category}.description`})}
                                    </p>
                                </Col>
                            </Row>
                        </div>
                    ))}
                </Carousel>
                <Row align="center">
                    <Link to={`/${locale}/contact`} className="full-width">
                        <Button type="ghost">
                            {formatMessage({id: 'workflow.button.label'})}
                        </Button>
                    </Link>
                </Row>
            </div>
        </div>
    );
};

export default WorkflowTabs;
